import React from 'react'
import Routes from 'routes'
import { withRouter } from 'react-router-dom'
import { Page, PageIntro, Icon } from 'components/library'
import { ModalPopup } from './'
import { Chapters } from 'content/chapters'
import { translate } from 'translations'
import { connect } from 'react-redux'

class SummaryModal extends React.Component {
  get progress() {
    let totalAspects = this.props.app.modalData.chapter.aspects.length
    if(this.props.app.modalData.chapter.summary) {
      totalAspects += 1
    }
    const currentAspect = totalAspects

    return {
      progress: currentAspect,
      total: totalAspects,
    }
  }

  handleHome = e => {
    this.props.history.push(Routes.to('home'))
    this.props.app.toggleModal()
  }

  handleContinue = e => {
    let nextRoute = Routes.to('home')
    const currentNavigationItem = this.props.navigation.find(item => item.chapterId === this.props.app.modalData.chapter.id)
    const currentNavigationItemIndex = this.props.navigation.indexOf(currentNavigationItem)
    const nextNavigationItemIndex = currentNavigationItemIndex + 1
    const nextNavigationItem = this.props.navigation[nextNavigationItemIndex]

    if(nextNavigationItem) {
      switch(nextNavigationItem.type) {
        case 'chapter':
          const nextChapter = this.props.chapters.find(item => item.id === nextNavigationItem.chapterId)
          nextRoute = Routes.to('chapter', { chapter: nextChapter.slug })
          break

        case 'page':
          const nextPage = this.props.pages.find(item => item.id === nextNavigationItem.pageId)
          nextRoute = Routes.to('page', { page: nextPage.slug })
          break

        case 'endtest':
          nextRoute = Routes.to('endtest')
          break;

        default:
      }
    }

    this.props.history.push(nextRoute)
    this.props.app.toggleModal()
  }

  render() {
    return (
      <ModalPopup {...this.props}>
        <Page name="Summary" theme={this.props.app.theme}>
          <PageIntro
            title={this.props.app.modalData.chapter.summary.title}
            description={this.props.app.modalData.chapter.summary.description}
            progress={this.progress}
            chapter={this.props.app.modalData.chapter}
            continueButtonLabel={translate('card.nextModule')}
            handleHome={this.handleHome}
            handleContinue={this.handleContinue}>
            <CurrentChapterSummary chapter={this.props.app.modalData.chapter} />
          </PageIntro>

          <a onClick={this.props.app.toggleModal} className="Modal-popup-close">
            <Icon name="close" />
          </a>
        </Page>
      </ModalPopup>
    )
  }
}

const CurrentChapterSummary = props => {
  const id = props.chapter.id < 10 ? `0${props.chapter.id}` : props.chapter.id
  const Chapter = Chapters[`Chapter${id}`]

  if(!Chapter) return <p>No Template</p>
  if(!Chapter.Summary) return <p>No Template</p>

  return <Chapter.Summary {...props} />
}

export default withRouter(connect(
  (state, props) => ({
    pages: state.content.pages,
    chapters: state.content.chapters,
    navigation: state.content.navigation,
  }),
  (dispatch) => ({})
)(SummaryModal))


// WEBPACK FOOTER //
// ./src/components/modals/SummaryModal.js